import React, { useCallback } from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import { List, Popup } from 'src/@vymo/ui/blocks';
import { ReactComponent as CloseButton } from 'src/assets/icons/close.svg';
import { ReactComponent as CopilotIcon } from 'src/assets/icons/copilot_icon.svg';
import { ReactComponent as MenuButton } from 'src/assets/icons/menuDots.svg';
import { Keys, locale } from 'src/i18n';
import { toggleCopilot } from 'src/models/appConfig/slice';
import { useAppDispatch } from 'src/store/hooks';
import { closePortal } from 'src/workspace/utils';
import { clearHistory } from './thunk';
import { CopilotVersion } from './types';
import styles from './index.module.scss';

function Header({ version = 'default' }: { version?: CopilotVersion }) {
  const dispatch = useAppDispatch();

  const closeCopilot = useCallback(() => {
    if (window.isWebPlatform) {
      dispatch(toggleCopilot());
    }
    const data = {
      code: 'close-activity',
      text: locale(Keys.CLOSE_COPILOT),
    };
    const messageData = JSON.stringify(data);
    // @ts-ignore
    if (window.Android) {
      // @ts-ignore
      window.Android.handleMessage(messageData);
    }
    // @ts-ignore
    if (window?.ReactNativeWebView?.postMessage) {
      // @ts-ignore
      window?.ReactNativeWebView?.postMessage(messageData, '*');
    }
    closePortal?.();
  }, [dispatch]);
  return (
    <div className={styles.copilotv2__header}>
      <CopilotIcon />
      <div className={styles.copilotv2__header__actions}>
        {version === 'default' && (
          <Popup
            placement="bottom"
            closeTrigger="click"
            content={
              <List>
                <List.Item>
                  <Button
                    type="text"
                    variant="filled"
                    onClick={() => dispatch(clearHistory())}
                  >
                    Clear History
                  </Button>
                </List.Item>
              </List>
            }
          >
            <Button
              onClick={() => {}}
              type="text"
              rounded
              isIcon
              className={styles.copilotv2__header__button}
              iconProps={{
                icon: <MenuButton />,
                iconPosition: 'left',
              }}
            />
          </Popup>
        )}
        <Button
          onClick={closeCopilot}
          type="text"
          rounded
          isIcon
          className={styles.copilotv2__header__button}
          iconProps={{
            icon: <CloseButton />,
            iconPosition: 'left',
          }}
        />
      </div>
    </div>
  );
}

export default Header;
